<template>
  <svg :width="width" :height="height" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 59.27 59.27"
       xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Layer_x0020_1">
  <metadata id="CorelCorpID_0Corel-Layer"/>
      <circle class="fil0" cx="29.64" cy="29.64" r="29.64"/>
      <g id="_2190173789360">
   <g id="Layer_x0020_1_0">
    <path class="fil1 str0" d="M35.8 40.22l0.01 -0.02 4.62 -4.62 1.59 -1.58 0 -1.66 0 -6.76 0 -3.17 0 -5.15 -16.7 0 -8.06 8.06 0 16.7 16.74 0 1.8 -1.8zm0 -17.89l0 3.08 -5.86 0c-1.94,0 -3.54,1.6 -3.54,3.55 0,1.94 1.6,3.54 3.54,3.54l5.86 0 0 3.08 -5.86 0c-3.64,0 -6.62,-2.98 -6.62,-6.62 0,-3.65 2.98,-6.63 6.62,-6.63l5.86 0z"/>
   </g>
  </g>
 </g>
</svg>
</template>

<script>
  export default {
    props: {
      width: {
        type: [Number, String],
        default: 300
      },
      height: {
        type: [Number, String],
        default: 300
      }
    }
  }
</script>

<style scoped>
  .str0 {stroke:#564A4C;stroke-width:0.95;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:2.61313}
  .fil0 {fill:#E6E6E6}
  .fil1 {fill:#F7A21C}
</style>